import { JsonObject, JsonProperty } from 'json2typescript';

@JsonObject('Ship')
export class Ship {
    @JsonProperty('id', Number, true)
    id: number = undefined;

    @JsonProperty('name', String, true)
    name = '';

    @JsonProperty('flag', String, true)
    flag = null;

    get nameFlag() {
        return this.name + ' - ' + this.flag;
    }
}